document.addEventListener('DOMContentLoaded', () => {
  const readMore = document.querySelector('.readMore');
  const allSubline = document.querySelector('.cosmetics-subline-bullets-others');
  const closeSubline = document.querySelector('.close-subline');
  if (readMore !== null) {
    readMore.addEventListener('click', () => {
      readMore.classList.add('hidden');
      if (allSubline !== null) {
        allSubline.classList.remove('hidden');
      }
    });
  }
  if (closeSubline !== null) {
    closeSubline.addEventListener('click', () => {
      readMore.classList.remove('hidden');
      allSubline.classList.add('hidden');
    });
  }
});
